import { render, staticRenderFns } from "./help-support-form.html?vue&type=template&id=c045bfa0&scoped=true&"
import script from "./help-support-form.js?vue&type=script&lang=js&"
export * from "./help-support-form.js?vue&type=script&lang=js&"
import style0 from "./help-support-form.scss?vue&type=style&index=0&id=c045bfa0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c045bfa0",
  null
  
)

export default component.exports